import clsx from "clsx";

type DividerProps = {
  className?: string;
};

export default function Divider({ className }: DividerProps) {
  return (
    <div
      className={clsx(
        "border-divider-secondary dark:border-divider-secondary-on-dark my-4 h-0 w-full shrink-0 border-t",
        className,
      )}
    />
  );
}
